var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_c('img',{attrs:{"src":require("../assets/images/404.png")}}),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]),_c('el-link',{attrs:{"href":"/"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }